export function stripHashQueryParam(param) {
  const raw = window.location.hash.slice(1)
  const [path, query = ''] = raw.split('?')
  const sp = new URLSearchParams(query)
  sp.delete(param)
  const newHash = `#${path}${sp.toString() ? `?${sp}` : ''}`
  history.replaceState(history.state, '', newHash)
}

export function getHashQueryParam(param) {
  const raw = location.hash.slice(1) // "/study/1365?goToTopicId=..."
  const [, query = ''] = raw.split('?')
  const sp = new URLSearchParams(query)
  return sp.get(param)
}
